import { AppCard } from "@/components/ui";
import { Lightbulb } from "lucide-react";

type TRecommendationsCardProps = {
  recommendations?: string[] | null;
};

export function RecommendationsCard({ recommendations }: TRecommendationsCardProps) {
  if (!recommendations || recommendations.length === 0) {
    return null;
  }

  return (
    <AppCard className="p-6">
      <div className="mb-4 flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
          <Lightbulb className="h-5 w-5 text-yellow-600" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Recommendations</h3>
      </div>
      <ul className="space-y-4">
        {recommendations.map((recommendation, index) => (
          <li
            key={index}
            className="flex items-start gap-4"
          >
            <div className="mt-0.5 flex-shrink-0">
              <Lightbulb className="h-5 w-5 text-yellow-600" />
            </div>
            <p className="text-sm leading-relaxed text-foreground">{recommendation}</p>
          </li>
        ))}
      </ul>
    </AppCard>
  );
}
